module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('md-tabs', [_c('md-tab', {
    attrs: {
      "md-icon": "home",
      "md-label": "Dashboard"
    }
  }, [_c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-6 grid-margin"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Top Clients")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1 text-muted"
  }, [_vm._v("\n                    By No. of Containers Executed\n                  ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart2"
    }
  }, [(_vm.showGraph == true) ? _c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "350",
      "options": _vm.chartOptionsRefuel,
      "series": _vm.seriesRefuel
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 grid-margin"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Top Place of Receipt")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1 text-muted"
  }, [_vm._v("\n                    By No. of Containers (Import)\n                  ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart2"
    }
  }, [(_vm.showGraph == true) ? _c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "350",
      "options": _vm.chartOptionsExDesti,
      "series": _vm.seriesExDesti
    }
  }) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-4"
  }, [_c('div', {
    staticClass: "col-md-6 grid-margin"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Top Shipping Line")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1 text-muted"
  }, [_vm._v("\n                    By No. of Containers Shipped\n                  ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart2"
    }
  }, [(_vm.showGraph == true) ? _c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "350",
      "options": _vm.chartOptionsShip,
      "series": _vm.seriesShip
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 grid-margin"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Top Imported Commodities")]), _vm._v(" "), _vm._l((_vm.topcommodity), function(item1, index) {
    return _c('div', {
      key: index,
      staticClass: "d-flex mt-3 py-2 border-bottom"
    }, [_c('div', [_c('p', {
      staticClass: "mb-n1 font-weight-semibold"
    }, [_vm._v("\n                        " + _vm._s(item1.itemDescription) + "\n                      ")])]), _vm._v(" "), _c('small', {
      staticClass: "text-muted ml-auto"
    }, [_vm._v("Exported " + _vm._s(item1.commodityCount) + " Times ")])])
  })], 2)])])])]), _vm._v(" "), _c('md-tab', {
    attrs: {
      "md-icon": "content_paste",
      "md-label": "CC Import Reports"
    }
  }, [_c('div', {
    staticClass: "mt-3"
  }, [_c('div', [_c('b-button', {
    class: _vm.visible ? null : 'collapsed',
    attrs: {
      "variant": "outline-dark",
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v("\n                Filters")]), _vm._v(" "), (_vm.importData.length > 0) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('CC_Import')
      }
    }
  }, [_vm._v("Export as Excel")]) : _vm._e()], 1), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-card', {
    staticClass: "gutr"
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.clientMaster,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name"
    },
    model: {
      value: (_vm.clientIdFilter),
      callback: function($$v) {
        _vm.clientIdFilter = $$v
      },
      expression: "clientIdFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20",
      "md-flex-small": "100"
    }
  }, [_c('date-range-picker', {
    attrs: {
      "opens": _vm.openLeft,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "update": function($event) {
        _vm.viewAssignment('0', '1', '1');
      }
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.filterSearch
    }
  }, [_vm._v("Search\n                  ")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [_c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.importData,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "seenExec",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "ccImportSeries",
      fn: function(row1) {
        return [_c('b', [_vm._v(_vm._s(row1.item.ccImportSeries))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Assignment Date : " + _vm._s(_vm._f("moment")(row1.item.dateAssignment)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Raised From : " + _vm._s(row1.item.EmpLoc))])]
      }
    }, {
      key: "ContainerNo",
      fn: function(row5) {
        return [(row5.item.ContainerNo != null) ? _c('div', [(row5.item.ContainerNo != null) ? _c('div', _vm._l((row5.item.ContainerNo.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == '' ? '-------' : item1))])], 1)])
        })) : _vm._e()]) : _c('div', [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "align": "center",
      "limit": "25",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e22bf60","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/reports/ccImportReports.vue
// module id = 2731
// module chunks = 0